'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
  }

  $onInit() {
    this.getScreenSaver();
  }

  getScreenSaver() {
    this.$http.get('/api/screenSavers').then(res => {
      this.screenSavers = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('api/screenSavers/' + id).then(response => {
        this.getScreenSaver();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/screenSaver/list/list.controller.js